import config from 'app/config'

const clientTheme = config.project.name

const santanderPalette = {
  common: {
    black: 'rgba(73, 73, 73, 1)',
    white: 'rgba(255, 255, 255, 1)'
  },
  white: {
    main: 'rgba(255, 255, 255, 1)'
  },
  background: {
    paper: 'rgba(255, 255, 255, 1)',
    default: '#f6f6f6'
  },
  primary: {
    light: '#dc2626',
    main: '#ec0000',
    dark: '#991b1b',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  secondary: {
    veryLight: 'rgba(245, 245, 245, 1)',
    middleVeryLight: 'rgba(224, 224, 224, 1)',
    middleLight: 'rgba(189, 189, 189, 1)',
    light: 'rgba(164, 164, 164, 1)',
    main: 'rgba(117, 117, 117, 1)',
    dark: 'rgba(73, 73, 73, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  info: {
    light: 'rgba(225, 245, 254, 1)',
    main: 'rgba(3, 169, 244, 1)',
    dark: 'rgba(73, 73, 73, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  blue: {
    veryLight: 'rgba(110, 206, 239, 1)',
    light: 'rgba(6, 170, 244, 1)',
    main: 'rgba(32, 102, 171, 0.94)',
    dark: 'rgba(15, 76, 92, 1)'
  },
  reds: {
    dark: '#b30b00'
  },
  success: {
    light: 'rgba(233, 245, 233, 1)',
    main: 'rgba(102, 187, 106, 1)',
    dark: 'rgba(102, 187, 106, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  purple: {
    middleLight: 'rgba(220, 210, 236, 1)',
    light: 'rgba(248, 246, 251, 1)',
    main: 'rgba(186, 165, 218, 1)',
    dark: 'rgba(149, 117, 205, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  error: {
    light: 'rgba(245, 233, 233, 1)',
    main: '#ff9800',
    dark: '#cc7900',
    contrastText: 'rgba(255, 255, 255, 1)',
    middleLight: 'rgba(204, 121, 0, 0.4)'
  },
  yellow: {
    veryLight: 'rgba(255, 255, 34, 1)',
    light: 'rgba(249, 196, 36, 1)',
    main: '#e6bb37'
  },
  warning: {
    light: '#FFECB3',
    main: '#FFC107',
    dark: '#FFC107',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  text: {
    main: 'rgba(73, 73, 73, 1)',
    primary: 'rgba(73, 73, 73, 1)',
    secondary: 'rgba(117, 117, 117, 1)',
    disabled: 'rgba(158, 158, 158, 1)',
    hint: 'rgba(0, 0, 0, 0.38)'
  },

  green: {
    middle: '#bce5be',
    middleLight: 'rgba(191, 221, 220, 1)',
    light: 'rgba(242, 248, 248, 1)',
    main: 'rgba(127, 186, 186, 1)',
    dark: 'rgba(1, 119, 117, 1)',
    bright: 'rgba(167, 207, 1, 1)',
    olive: 'rgba(129, 154, 22, 1)'
  },

  pink: {
    veryLight: 'rgba(252, 222, 222, 1)',
    middleLight: 'rgba(241, 199, 219, 1)',
    light: 'rgba(252, 244, 248, 1)',
    main: 'rgba(227, 143, 182, 1)',
    dark: 'rgba(200, 32, 111, 1)'
  },

  grey: {
    10: '#ffff',
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161'
  },

  orange: {
    middleLight: 'rgba(246, 218, 191, 1)',
    light: 'rgba(253, 247, 242, 1)',
    main: 'rgba(237,180,127, 1)',
    middle: 'rgba(251, 112, 17, 1)',
    dark: 'rgba(221, 106, 0, 1)'
  },

  card: {
    contract: {
      total: 'rgb(143, 223, 130)',
      active: 'rgb(208, 157, 110)',
      completed: 'rgb(130, 178, 223)',
      migrated: 'rgb(158, 158, 158)'
    },
    average: {
      duration: 'rgb(201, 187, 60)',
      ticket: 'rgb(164, 153, 61)',
      rate: 'rgb(79, 168, 146)'
    }
  }
}

const consignetPalette = {
  common: {
    black: 'rgba(73, 73, 73, 1)',
    white: 'rgba(255, 255, 255, 1)'
  },
  white: {
    main: 'rgba(255, 255, 255, 1)'
  },
  background: {
    paper: 'rgba(255, 255, 255, 1)',
    default: '#f6f6f6'
  },
  primary: {
    light: 'rgba(152, 238, 153, 1)',
    main: 'rgba(102, 187, 106, 1)',
    dark: 'rgba(27, 94, 32, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  secondary: {
    veryLight: 'rgba(245, 245, 245, 1)',
    middleVeryLight: 'rgba(224, 224, 224, 1)',
    middleLight: 'rgba(189, 189, 189, 1)',
    light: 'rgba(164, 164, 164, 1)',
    main: 'rgba(117, 117, 117, 1)',
    dark: 'rgba(73, 73, 73, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  info: {
    light: 'rgba(225, 245, 254, 1)',
    main: 'rgba(3, 169, 244, 1)',
    dark: 'rgba(73, 73, 73, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  blue: {
    veryLight: 'rgba(110, 206, 239, 1)',
    light: 'rgba(6, 170, 244, 1)',
    main: 'rgba(32, 102, 171, 0.94)',
    dark: 'rgba(15, 76, 92, 1)'
  },
  reds: {
    dark: '#b30b00'
  },
  success: {
    light: 'rgba(233, 245, 233, 1)',
    main: 'rgba(102, 187, 106, 1)',
    dark: 'rgba(102, 187, 106, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  purple: {
    middleLight: 'rgba(220, 210, 236, 1)',
    light: 'rgba(248, 246, 251, 1)',
    main: 'rgba(186, 165, 218, 1)',
    dark: 'rgba(149, 117, 205, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  error: {
    light: 'rgba(245, 233, 233, 1)',
    main: '#f44336',
    dark: '#d32f2f',
    contrastText: 'rgba(255, 255, 255, 1)',
    middleLight: 'rgba(255, 99, 71, 0.4)'
  },
  yellow: {
    veryLight: 'rgba(255, 255, 34, 1)',
    light: 'rgba(249, 196, 36, 1)',
    main: '#e6bb37'
  },
  warning: {
    light: '#FFECB3',
    main: '#FFC107',
    dark: '#FFC107',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  text: {
    main: 'rgba(73, 73, 73, 1)',
    primary: 'rgba(73, 73, 73, 1)',
    secondary: 'rgba(117, 117, 117, 1)',
    disabled: 'rgba(158, 158, 158, 1)',
    hint: 'rgba(0, 0, 0, 0.38)'
  },

  green: {
    middle: '#bce5be',
    middleLight: 'rgba(191, 221, 220, 1)',
    light: 'rgba(242, 248, 248, 1)',
    main: 'rgba(127, 186, 186, 1)',
    dark: 'rgba(1, 119, 117, 1)',
    bright: 'rgba(167, 207, 1, 1)',
    olive: 'rgba(129, 154, 22, 1)'
  },

  pink: {
    veryLight: 'rgba(252, 222, 222, 1)',
    middleLight: 'rgba(241, 199, 219, 1)',
    light: 'rgba(252, 244, 248, 1)',
    main: 'rgba(227, 143, 182, 1)',
    dark: 'rgba(200, 32, 111, 1)'
  },

  grey: {
    10: '#ffff',
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161'
  },

  orange: {
    middleLight: 'rgba(246, 218, 191, 1)',
    light: 'rgba(253, 247, 242, 1)',
    main: 'rgba(237,180,127, 1)',
    middle: 'rgba(251, 112, 17, 1)',
    dark: 'rgba(221, 106, 0, 1)'
  },

  card: {
    contract: {
      total: 'rgb(143, 223, 130)',
      active: 'rgb(208, 157, 110)',
      completed: 'rgb(130, 178, 223)',
      migrated: 'rgb(158, 158, 158)'
    },
    average: {
      duration: 'rgb(201, 187, 60)',
      ticket: 'rgb(164, 153, 61)',
      rate: 'rgb(79, 168, 146)'
    }
  }
}

const mixtraPalette = {
  common: {
    black: 'rgba(73, 73, 73, 1)',
    white: 'rgba(255, 255, 255, 1)'
  },
  white: {
    main: 'rgba(255, 255, 255, 1)'
  },
  background: {
    paper: 'rgba(255, 255, 255, 1)',
    default: '#f6f6f6'
  },
  primary: {
    light: 'rgba(97, 152, 232, 1)',
    main: 'rgba(000, 166, 182, 1)',
    dark: 'rgba(000, 36, 89, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  secondary: {
    veryLight: 'rgba(245, 245, 245, 1)',
    middleVeryLight: 'rgba(224, 224, 224, 1)',
    middleLight: 'rgba(189, 189, 189, 1)',
    light: 'rgba(164, 164, 164, 1)',
    main: 'rgba(171, 178, 178, 1)',
    dark: 'rgba(73, 73, 73, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  info: {
    light: 'rgba(225, 245, 254, 1)',
    main: 'rgba(3, 169, 244, 1)',
    dark: 'rgba(73, 73, 73, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  blue: {
    veryLight: 'rgba(110, 206, 239, 1)',
    light: 'rgba(6, 170, 244, 1)',
    main: 'rgba(32, 102, 171, 0.94)',
    dark: 'rgba(15, 76, 92, 1)'
  },
  reds: {
    dark: '#b30b00'
  },
  success: {
    light: 'rgba(233, 245, 233, 1)',
    main: 'rgba(102, 187, 106, 1)',
    dark: 'rgba(102, 187, 106, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  purple: {
    middleLight: 'rgba(220, 210, 236, 1)',
    light: 'rgba(248, 246, 251, 1)',
    main: 'rgba(186, 165, 218, 1)',
    dark: 'rgba(149, 117, 205, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  error: {
    light: 'rgba(245, 233, 233, 1)',
    main: '#f44336',
    dark: '#d32f2f',
    contrastText: 'rgba(255, 255, 255, 1)',
    middleLight: 'rgba(255, 99, 71, 0.4)'
  },
  yellow: {
    veryLight: 'rgba(255, 255, 34, 1)',
    light: 'rgba(249, 196, 36, 1)',
    main: 'rgba(230, 187, 55, 1)'
  },
  warning: {
    light: '#FFECB3',
    main: '#FFC107',
    dark: '#FFC107',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  text: {
    main: 'rgba(73, 73, 73, 1)',
    primary: 'rgba(73, 73, 73, 1)',
    secondary: 'rgba(117, 117, 117, 1)',
    disabled: 'rgba(158, 158, 158, 1)',
    hint: 'rgba(0, 0, 0, 0.38)'
  },

  green: {
    middle: '#bce5be',
    middleLight: 'rgba(191, 221, 220, 1)',
    light: 'rgba(242, 248, 248, 1)',
    main: 'rgba(127, 186, 186, 1)',
    dark: 'rgba(1, 119, 117, 1)',
    bright: 'rgba(167, 207, 1, 1)',
    olive: 'rgba(129, 154, 22, 1)'
  },

  pink: {
    veryLight: 'rgba(252, 222, 222, 1)',
    middleLight: 'rgba(241, 199, 219, 1)',
    light: 'rgba(252, 244, 248, 1)',
    main: 'rgba(227, 143, 182, 1)',
    dark: 'rgba(200, 32, 111, 1)'
  },

  grey: {
    10: '#ffff',
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161'
  },

  orange: {
    middleLight: 'rgba(246, 218, 191, 1)',
    light: 'rgba(253, 247, 242, 1)',
    main: 'rgba(237,180,127, 1)',
    middle: 'rgba(251, 112, 17, 1)',
    dark: 'rgba(221, 106, 0, 1)'
  },

  card: {
    contract: {
      total: 'rgb(143, 223, 130)',
      active: 'rgb(208, 157, 110)',
      completed: 'rgb(130, 178, 223)',
      migrated: 'rgb(158, 158, 158)'
    },
    average: {
      duration: 'rgb(201, 187, 60)',
      ticket: 'rgb(164, 153, 61)',
      rate: 'rgb(79, 168, 146)'
    }
  }
}

const caixaPalette = {
  common: {
    black: 'rgba(73, 73, 73, 1)',
    white: 'rgba(255, 255, 255, 1)'
  },
  white: {
    main: 'rgba(255, 255, 255, 1)'
  },
  background: {
    paper: 'rgba(255, 255, 255, 1)',
    default: '#f6f6f6'
  },
  primary: {
    light: 'rgba(76, 133, 194, 1)',
    main: 'rgba(3, 94, 170, 1)',
    dark: 'rgba(2, 66, 119, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  secondary: {
    veryLight: 'rgba(245, 245, 245, 1)',
    middleVeryLight: 'rgba(224, 224, 224, 1)',
    middleLight: 'rgba(189, 189, 189, 1)',
    light: 'rgba(164, 164, 164, 1)',
    main: 'rgba(171, 178, 178, 1)',
    dark: 'rgba(73, 73, 73, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  info: {
    light: 'rgba(225, 245, 254, 1)',
    main: 'rgba(3, 169, 244, 1)',
    dark: 'rgba(73, 73, 73, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  blue: {
    veryLight: 'rgba(110, 206, 239, 1)',
    light: 'rgba(6, 170, 244, 1)',
    main: 'rgba(32, 102, 171, 0.94)',
    dark: 'rgba(15, 76, 92, 1)'
  },
  reds: {
    dark: '#b30b00'
  },
  success: {
    light: 'rgba(233, 245, 233, 1)',
    main: 'rgba(102, 187, 106, 1)',
    dark: 'rgba(102, 187, 106, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  purple: {
    middleLight: 'rgba(220, 210, 236, 1)',
    light: 'rgba(248, 246, 251, 1)',
    main: 'rgba(186, 165, 218, 1)',
    dark: 'rgba(149, 117, 205, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  error: {
    light: 'rgba(245, 233, 233, 1)',
    main: '#f44336',
    dark: '#d32f2f',
    contrastText: 'rgba(255, 255, 255, 1)',
    middleLight: 'rgba(255, 99, 71, 0.4)'
  },
  yellow: {
    veryLight: 'rgba(255, 255, 34, 1)',
    light: 'rgba(249, 196, 36, 1)',
    main: 'rgba(230, 187, 55, 1)'
  },
  warning: {
    light: '#FFECB3',
    main: '#FFC107',
    dark: '#FFC107',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  text: {
    main: 'rgba(73, 73, 73, 1)',
    primary: 'rgba(73, 73, 73, 1)',
    secondary: 'rgba(117, 117, 117, 1)',
    disabled: 'rgba(158, 158, 158, 1)',
    hint: 'rgba(0, 0, 0, 0.38)'
  },

  green: {
    middle: '#bce5be',
    middleLight: 'rgba(191, 221, 220, 1)',
    light: 'rgba(242, 248, 248, 1)',
    main: 'rgba(127, 186, 186, 1)',
    dark: 'rgba(1, 119, 117, 1)',
    bright: 'rgba(167, 207, 1, 1)',
    olive: 'rgba(129, 154, 22, 1)'
  },

  pink: {
    veryLight: 'rgba(252, 222, 222, 1)',
    middleLight: 'rgba(241, 199, 219, 1)',
    light: 'rgba(252, 244, 248, 1)',
    main: 'rgba(227, 143, 182, 1)',
    dark: 'rgba(200, 32, 111, 1)'
  },

  grey: {
    10: '#ffff',
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161'
  },

  orange: {
    middleLight: 'rgba(246, 218, 191, 1)',
    light: 'rgba(253, 247, 242, 1)',
    main: 'rgba(237,180,127, 1)',
    middle: 'rgba(251, 112, 17, 1)',
    dark: 'rgba(221, 106, 0, 1)'
  },

  card: {
    contract: {
      total: 'rgb(143, 223, 130)',
      active: 'rgb(208, 157, 110)',
      completed: 'rgb(130, 178, 223)',
      migrated: 'rgb(158, 158, 158)'
    },
    average: {
      duration: 'rgb(201, 187, 60)',
      ticket: 'rgb(164, 153, 61)',
      rate: 'rgb(79, 168, 146)'
    }
  }
}

const crefazPalette = {
  common: {
    black: 'rgba(73, 73, 73, 1)',
    white: 'rgba(255, 255, 255, 1)'
  },
  white: {
    main: 'rgba(255, 255, 255, 1)'
  },
  background: {
    paper: 'rgba(255, 255, 255, 1)',
    default: '#f6f6f6'
  },
  primary: {
    light: 'rgba(252, 151, 66, 1)',
    main: 'rgb(239, 107, 34, 1)',
    dark: 'rgba(224, 105, 4, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  secondary: {
    veryLight: 'rgba(245, 245, 245, 1)',
    middleVeryLight: 'rgba(224, 224, 224, 1)',
    middleLight: 'rgba(189, 189, 189, 1)',
    light: 'rgba(164, 164, 164, 1)',
    main: 'rgba(171, 178, 178, 1)',
    dark: 'rgba(73, 73, 73, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  info: {
    light: 'rgba(225, 245, 254, 1)',
    main: 'rgba(3, 169, 244, 1)',
    dark: 'rgba(73, 73, 73, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  blue: {
    veryLight: 'rgba(110, 206, 239, 1)',
    light: 'rgba(6, 170, 244, 1)',
    main: 'rgba(32, 102, 171, 0.94)',
    dark: 'rgba(15, 76, 92, 1)'
  },
  reds: {
    dark: '#b30b00'
  },
  success: {
    light: 'rgba(233, 245, 233, 1)',
    main: 'rgba(102, 187, 106, 1)',
    dark: 'rgba(102, 187, 106, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  purple: {
    middleLight: 'rgba(220, 210, 236, 1)',
    light: 'rgba(248, 246, 251, 1)',
    main: 'rgba(186, 165, 218, 1)',
    dark: 'rgba(149, 117, 205, 1)',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  error: {
    light: 'rgba(245, 233, 233, 1)',
    main: '#f44336',
    dark: '#d32f2f',
    contrastText: 'rgba(255, 255, 255, 1)',
    middleLight: 'rgba(255, 99, 71, 0.4)'
  },
  yellow: {
    veryLight: 'rgba(255, 255, 34, 1)',
    light: 'rgba(249, 196, 36, 1)',
    main: 'rgba(230, 187, 55, 1)'
  },
  warning: {
    light: '#FFECB3',
    main: '#FFC107',
    dark: '#FFC107',
    contrastText: 'rgba(255, 255, 255, 1)'
  },
  text: {
    main: 'rgba(73, 73, 73, 1)',
    primary: 'rgba(73, 73, 73, 1)',
    secondary: 'rgba(117, 117, 117, 1)',
    disabled: 'rgba(158, 158, 158, 1)',
    hint: 'rgba(0, 0, 0, 0.38)'
  },

  green: {
    middle: '#bce5be',
    middleLight: 'rgba(191, 221, 220, 1)',
    light: 'rgba(242, 248, 248, 1)',
    main: 'rgba(127, 186, 186, 1)',
    dark: 'rgba(1, 119, 117, 1)',
    bright: 'rgba(167, 207, 1, 1)',
    olive: 'rgba(129, 154, 22, 1)'
  },

  pink: {
    veryLight: 'rgba(252, 222, 222, 1)',
    middleLight: 'rgba(241, 199, 219, 1)',
    light: 'rgba(252, 244, 248, 1)',
    main: 'rgba(227, 143, 182, 1)',
    dark: 'rgba(200, 32, 111, 1)'
  },

  grey: {
    10: '#ffff',
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161'
  },

  orange: {
    middleLight: 'rgba(246, 218, 191, 1)',
    light: 'rgba(253, 247, 242, 1)',
    main: 'rgba(237,180,127, 1)',
    middle: 'rgba(251, 112, 17, 1)',
    dark: 'rgba(221, 106, 0, 1)'
  },

  card: {
    contract: {
      total: 'rgb(143, 223, 130)',
      active: 'rgb(208, 157, 110)',
      completed: 'rgb(130, 178, 223)',
      migrated: 'rgb(158, 158, 158)'
    },
    average: {
      duration: 'rgb(201, 187, 60)',
      ticket: 'rgb(164, 153, 61)',
      rate: 'rgb(79, 168, 146)'
    }
  }
}

const paletteByClient = {
  CONSIGNET: consignetPalette,
  MIXTRA: mixtraPalette,
  SANTANDER: santanderPalette,
  CAIXA: caixaPalette,
  CREFAZ: crefazPalette,
  DEFAULT: consignetPalette
}

const palette = paletteByClient[clientTheme || 'DEFAULT']

export default palette
